import { jsx as _jsx } from "react/jsx-runtime";
import { ContentBody } from "./ContentBody";
import { TooltipInfos } from "../tooltip";
import { InfoCircleIcon } from "@gemini/icons";
export const DsaElement = () => (_jsx(TooltipInfos, { content: _jsx(ContentBody, {}), icon: _jsx(InfoCircleIcon, { size: "sizing.16", color: "color.content.light.default", position: "relative" }), iconPadding: "spacing.none" }));
